import React, { useEffect, useState } from "react";
import classes from "./ArticleCard.module.scss";
import timeIcon from "../../assets/img/clock.svg";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import { ConfirmModal } from "../UIkit/modal/ConfirmModal";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";
import {
  hideLoadingAction,
  showLoadingAction,
} from "../../reducks/loading/actions";
import classNames from "classnames";
import { isCurrentDateWithinRange } from "../../functions/utils/formatting";
import { getUserInfo } from "../../reducks/users/selectors";
const ArticleCard = (props) => {
  const { article, isAdministrator } = props;
  const [isShowDeleteDialog, setIsShowDeleteDialog] = React.useState(false);
  const userInfo = useSelector(getUserInfo);
  const [isOpend, setIsOpend] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    const targetUser = article.targetUsers.find(
      (targetUser) => targetUser.email === userInfo.email
    );
    if (targetUser) {
      if (targetUser.isOpened) {
        setIsOpend(true);
      } else {
        setIsOpend(false);
      }
    } else {
      setIsOpend(false);
    }
  }, [userInfo.email]);
  const handleDeleteArticle = async () => {
    if (!article.id) {
      setIsShowDeleteDialog(false);
      return;
    }

    try {
      // Firebase Firestore からドキュメントを削除
      dispatch(showLoadingAction("削除中..."));
      const articleRef = doc(db, "articles", article.id);
      await deleteDoc(articleRef);
      console.log("記事が削除されました:", article.id);
    } catch (error) {
      console.error("記事の削除中にエラーが発生しました:", error);
    } finally {
      // ダイアログを閉じる
      dispatch(hideLoadingAction());
      setIsShowDeleteDialog(false);
    }
  };
  const handleNavigation = async (path) => {
    await dispatch(push(path));
  };
  return (
    <div
      className={classNames(
        classes.container,
        !isOpend ? classes.notOpenBackground : ""
      )}
    >
      <div className={classes.firstContant}>
        <div className={classes.dateAndCategory}>
          <div
            className={classNames(
              classes.date,
              !isOpend ? classes.notOpenFontStyle : ""
            )}
          >
            <img src={timeIcon} />
            {article.createdDay}
          </div>
          <div
            className={classNames(
              classes.category,
              !isOpend ? classes.notOpenFontStyleCategory : ""
            )}
          >
            {article.category}
          </div>
        </div>
        <div
          className={classNames(
            classes.title,
            !isOpend ? classes.notOpenFontStyle : ""
          )}
        >
          {article.title}
        </div>
      </div>

      {/* {isAdministrator && ( */}
      <div className={classes.thirdContent}>
        {isAdministrator && (
          <div
            className={classNames(
              classes.publisStatus,
              article.publishStatus === "公開" ? classes.published : ""
            )}
          >
            {article.publishStatus}
          </div>
        )}
        {article.notice && (
          <div className={classes.notice}>
            <div
              className={classNames(
                classes.title,
                !isCurrentDateWithinRange(
                  article.noticeFromDate,
                  article.noticeToDate
                )
                  ? classes.disabled
                  : classes.enabled
              )}
            >
              通知
            </div>
            <div
              className={classNames(
                classes.date,
                isCurrentDateWithinRange(
                  article.noticeFromDate,
                  article.noticeToDate
                )
                  ? classes.isInRange
                  : classes.isOutRange
              )}
            >
              <p>開始:{article.noticeFromDate}</p>
              <p>終了:{article.noticeToDate}</p>
            </div>
          </div>
        )}
      </div>
      {/* )} */}
      <div className={classes.forthContant}>
        <div
          className={classes.button}
          onClick={() => handleNavigation(`/notice/detail/${article.id}`)}
        >
          確認
          <ArrowForwardIcon className={classes.icon} />
        </div>
        {isAdministrator && (
          <>
            <div
              className={classes.button}
              onClick={() => handleNavigation(`/notice/edit/${article.id}`)}
            >
              編集
              <EditIcon className={classes.icon} />
            </div>
            <div
              className={classes.button}
              onClick={() => setIsShowDeleteDialog(true)}
            >
              削除
              <DeleteIcon className={classes.icon} />
            </div>
          </>
        )}
      </div>
      {isShowDeleteDialog && article.id && (
        <ConfirmModal
          setIsShow={setIsShowDeleteDialog}
          title="確認"
          message={"元に戻せません。よろしいですか？"}
          onExec={handleDeleteArticle}
          onCancel={() => setIsShowDeleteDialog(false)}
        />
      )}
    </div>
  );
};

export default ArticleCard;
